export default {"src":"/_next/static/media/icon-1.93a8e3f7.svg","height":79,"width":92,"blurWidth":0,"blurHeight":0};